import React, { Fragment } from 'react';

import Header from './common/Header';
import video from '../assets/no-match.mp4';

export default function NoMatch() {
  return (
    <Fragment>
      <Header />
      <main className="container ">
        <section className="no-match">
          <video autoPlay muted>
            <source src={video} />
          </video>
        </section>
      </main>
    </Fragment>
  );
}
